export default __webpack_public_path__ + "static/media/share.3a67d11b.svg";